import {isBrowser, isDevelopment} from "../../app/utils/read_environment_variables";
import {isAnalyticsDebugMode} from "../common/track_event";

/**
 * Meta Pixel standard event (CompleteRegistration, Lead, Purchase, …).
 * Relies on the Pixel already injected by GTM — does not load a second snippet.
 */
export const hitFacebookPixelEvent = (eventName: string): void => {
    if (!isBrowser || !eventName) {
        return;
    }

    try {
        if (typeof window.fbq !== "function") {
            return;
        }
        window.fbq("track", eventName);
        if (isDevelopment || isAnalyticsDebugMode()) {
            console.info("[Meta Pixel]", eventName);
        }
    } catch {
        // never break UX because of analytics
    }
};
